export default __webpack_public_path__ + "static/media/pablo.1431bb50.jpg";